import { GridCellProps } from "@progress/kendo-react-grid";
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs";

export function IsUnloadedInMultiDockCell(props: GridCellProps) {
  const { dataItem, field, onChange } = props;

  const myField = field || "";
  const dataValue = dataItem[myField];

  const handleChange = (e: CheckboxChangeEvent) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  return (
    <td>
      <Checkbox value={dataValue} onChange={handleChange} />
    </td>
  );
}
